import { useEffect } from 'react';
import shallow from 'zustand/shallow';

import useStore from './index';

import { SectionEnum } from '../types';
import { PaywallFeatureEnum as PAYWALL } from '../constants';

function useChartbit(symbol: string) {
  const { isPro, isLoading, isRenewal, getStatus, addCounter } = useStore(
    (state) => ({
      isPro: state.company.isPro,
      isRenewal: state.company.isRenewal,
      isLoading: state.company.isLoading,
      getStatus: state.getStatus,
      addCounter: state.addCounter,
    }),
    shallow,
  );

  useEffect(() => {
    if (!symbol) return;

    const feature = PAYWALL.CHARTBIT;
    getStatus({ key: SectionEnum.company, feature, company: symbol });
    addCounter({ feature, company: symbol });
  }, [symbol]);

  return {
    isPro,
    isLoading,
    isRenewal,
  };
}

export default useChartbit;
